var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _vm.showForm
                ? _c("check-replay-modal", {
                    ref: "modalForm",
                    attrs: { formMode: _vm.formMode },
                    on: { ok: _vm.modalFormOk, cancel: _vm.modalFormClose },
                  })
                : _vm._e(),
              !_vm.showForm
                ? [
                    _c(
                      "div",
                      { staticClass: "table-page-search-wrapper" },
                      [
                        _c(
                          "a-form",
                          {
                            attrs: { layout: "inline" },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchQuery.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据编号",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入单据编号",
                                          },
                                          model: {
                                            value: _vm.queryParam.number,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "number",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.number",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "商品信息",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入条码、名称、助记码、规格、型号等信息",
                                          },
                                          model: {
                                            value: _vm.queryParam.materialParam,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "materialParam",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.materialParam",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据日期",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-range-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            format: "YYYY-MM-DD",
                                            placeholder: [
                                              "开始时间",
                                              "结束时间",
                                            ],
                                          },
                                          on: { change: _vm.onDateChange },
                                          model: {
                                            value:
                                              _vm.queryParam.createTimeRange,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "createTimeRange",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.createTimeRange",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "table-page-search-submitButtons",
                                    staticStyle: {
                                      float: "left",
                                      overflow: "hidden",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: { click: _vm.searchQuery },
                                          },
                                          [_vm._v("查询")]
                                        ),
                                        _c(
                                          "a-button",
                                          {
                                            staticStyle: {
                                              "margin-left": "8px",
                                            },
                                            on: { click: _vm.searchReset },
                                          },
                                          [_vm._v("重置")]
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              "margin-left": "8px",
                                            },
                                            on: {
                                              click: _vm.handleToggleSearch,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.toggleSearchStatus
                                                    ? "收起"
                                                    : "展开"
                                                ) +
                                                "\n                    "
                                            ),
                                            _c("a-icon", {
                                              attrs: {
                                                type: _vm.toggleSearchStatus
                                                  ? "up"
                                                  : "down",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.toggleSearchStatus
                              ? [
                                  _c(
                                    "a-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "仓库名称",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder: "请选择仓库",
                                                    showSearch: "",
                                                    "allow-clear": "",
                                                    optionFilterProp:
                                                      "children",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam.depotId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "depotId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.depotId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.depotList,
                                                  function (depot, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: depot.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              depot.depotName
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "操作员",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder: "请选择操作员",
                                                    showSearch: "",
                                                    "allow-clear": "",
                                                    optionFilterProp:
                                                      "children",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam.creator,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "creator",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.creator",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.userList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              item.userName
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "关联单据",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c("a-input", {
                                                attrs: {
                                                  placeholder:
                                                    "请输入关联盘点录入单号",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryParam.linkNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryParam,
                                                      "linkNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryParam.linkNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "单据状态",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      "请选择单据状态",
                                                    "allow-clear": "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.status",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select-option",
                                                    { attrs: { value: "0" } },
                                                    [_vm._v("未审核")]
                                                  ),
                                                  !_vm.checkFlag
                                                    ? _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: { value: "9" },
                                                        },
                                                        [_vm._v("审核中")]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "a-select-option",
                                                    { attrs: { value: "1" } },
                                                    [_vm._v("已审核")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "table-operator",
                        staticStyle: { "margin-top": "5px" },
                      },
                      [
                        _vm.btnEnableList.indexOf(1) > -1
                          ? _c(
                              "a-button",
                              {
                                attrs: { type: "primary", icon: "plus" },
                                on: { click: _vm.myHandleAdd },
                              },
                              [_vm._v("新增")]
                            )
                          : _vm._e(),
                        _vm.btnEnableList.indexOf(1) > -1
                          ? _c(
                              "a-button",
                              {
                                attrs: { icon: "delete" },
                                on: { click: _vm.batchDel },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                        _vm.checkFlag && _vm.btnEnableList.indexOf(2) > -1
                          ? _c(
                              "a-button",
                              {
                                attrs: { icon: "check" },
                                on: {
                                  click: function ($event) {
                                    return _vm.batchSetStatus(1)
                                  },
                                },
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                        _vm.checkFlag && _vm.btnEnableList.indexOf(7) > -1
                          ? _c(
                              "a-button",
                              {
                                attrs: { icon: "stop" },
                                on: {
                                  click: function ($event) {
                                    return _vm.batchSetStatus(0)
                                  },
                                },
                              },
                              [_vm._v("反审核")]
                            )
                          : _vm._e(),
                        _vm.isShowExcel && _vm.btnEnableList.indexOf(3) > -1
                          ? _c(
                              "a-button",
                              {
                                attrs: { icon: "download" },
                                on: { click: _vm.handleExport },
                              },
                              [_vm._v("导出")]
                            )
                          : _vm._e(),
                        _c(
                          "a-popover",
                          { attrs: { trigger: "click", placement: "right" } },
                          [
                            _c(
                              "template",
                              { slot: "content" },
                              [
                                _c(
                                  "a-checkbox-group",
                                  {
                                    attrs: {
                                      defaultValue: _vm.settingDataIndex,
                                    },
                                    on: { change: _vm.onColChange },
                                    model: {
                                      value: _vm.settingDataIndex,
                                      callback: function ($$v) {
                                        _vm.settingDataIndex = $$v
                                      },
                                      expression: "settingDataIndex",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-row",
                                      { staticStyle: { width: "500px" } },
                                      [
                                        _vm._l(
                                          _vm.defColumns,
                                          function (item, index) {
                                            return [
                                              item.dataIndex != "action"
                                                ? [
                                                    _c(
                                                      "a-col",
                                                      { attrs: { span: 8 } },
                                                      [
                                                        _c(
                                                          "a-checkbox",
                                                          {
                                                            attrs: {
                                                              value:
                                                                item.dataIndex,
                                                            },
                                                          },
                                                          [
                                                            _c("j-ellipsis", {
                                                              attrs: {
                                                                value:
                                                                  item.title,
                                                                length: 10,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "a-row",
                                      {
                                        staticStyle: { "padding-top": "10px" },
                                      },
                                      [
                                        _c(
                                          "a-col",
                                          [
                                            _vm._v(
                                              "\n                    恢复默认列配置："
                                            ),
                                            _c(
                                              "a-button",
                                              {
                                                attrs: {
                                                  type: "link",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: _vm.handleRestDefault,
                                                },
                                              },
                                              [_vm._v("恢复默认")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("a-button", { attrs: { icon: "setting" } }, [
                              _vm._v("列设置"),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            size: "middle",
                            bordered: "",
                            rowKey: "id",
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                            pagination: _vm.ipagination,
                            scroll: _vm.scroll,
                            loading: _vm.loading,
                            rowSelection: {
                              selectedRowKeys: _vm.selectedRowKeys,
                              onChange: _vm.onSelectChange,
                            },
                            expandedRowKeys: _vm.expandedRowKeys,
                          },
                          on: {
                            expand: _vm.onExpand,
                            change: _vm.handleTableChange,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "action",
                                fn: function (text, record) {
                                  return _c(
                                    "span",
                                    {},
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.myHandleDetail(
                                                record,
                                                "盘点复盘",
                                                _vm.prefixNo
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("查看")]
                                      ),
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c("a-divider", {
                                            attrs: { type: "vertical" },
                                          })
                                        : _vm._e(),
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.myHandleEdit(
                                                    record
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("编辑")]
                                          )
                                        : _vm._e(),
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c("a-divider", {
                                            attrs: { type: "vertical" },
                                          })
                                        : _vm._e(),
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.myHandleCopyAdd(
                                                    record
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("复制")]
                                          )
                                        : _vm._e(),
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c("a-divider", {
                                            attrs: { type: "vertical" },
                                          })
                                        : _vm._e(),
                                      _vm.btnEnableList.indexOf(1) > -1
                                        ? _c(
                                            "a-popconfirm",
                                            {
                                              attrs: { title: "确定删除吗?" },
                                              on: {
                                                confirm: () =>
                                                  _vm.myHandleDelete(record),
                                              },
                                            },
                                            [_c("a", [_vm._v("删除")])]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                },
                              },
                              {
                                key: "customRenderStatus",
                                fn: function (status) {
                                  return [
                                    status == "0"
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "red" } },
                                          [_vm._v("未审核")]
                                        )
                                      : _vm._e(),
                                    status == "1"
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "green" } },
                                          [_vm._v("已审核")]
                                        )
                                      : _vm._e(),
                                    status == "9"
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "orange" } },
                                          [_vm._v("审核中")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "expandedRowRender",
                                fn: function (record) {
                                  return _c("a-table", {
                                    attrs: {
                                      bordered: "",
                                      size: "small",
                                      loading: record.loading,
                                      columns: _vm.detailColumns,
                                      dataSource: record.childrens,
                                      "row-key": (record) => record.id,
                                      pagination: false,
                                    },
                                  })
                                },
                              },
                            ],
                            null,
                            false,
                            2983995458
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c("bill-excel-iframe", {
                ref: "billExcelIframe",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
              _c("bill-detail", {
                ref: "modalDetail",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }